import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetPARAMS,
  SetTASK,
} from "../../../../../../../../services/redux/slices/diagnostics/laboratory/validator";
import { MDBTable } from "mdbreact";
import { Echo } from "../../../../../../../../services/fakeDb";

export default function TissueDopler({
  setActiveTab = () => {},
  activeTab = "",
}) {
  const { task, showModal } = useSelector(({ validator }) => validator);
  const dispatch = useDispatch();

  // pull array or default
  const tissueValues = Array.isArray(task?.tissue) ? task.tissue : [];

  // refs for inputs
  const inputRefs = useRef([]);

  // auto-focus when modal opens
  useEffect(() => {
    if (showModal && activeTab === "Tissue") {
      setTimeout(() => {
        inputRefs.current?.[0]?.[0]?.focus();
      }, 400);
    }
  }, [showModal, activeTab]);

  const handleChange = (value, index, cIdx) => {
    const numericValue = value === "" ? "" : parseFloat(value);

    // clone and pad to match Echo.tissue length
    const updated = [...tissueValues];
    updated[index] = Array.isArray(updated[index]) ? [...updated[index]] : [];

    updated[index][cIdx] = numericValue;

    const newTask = {
      ...task,
      tissue: updated,
    };
    // ensure full length
    const padded = Array(Echo.TissueDoppler.length) // number of rows
      .fill("")
      .map((_, i) =>
        Array(3)
          .fill("")
          .map((__, j) =>
            Array.isArray(updated[i]) ? updated[i][j] ?? "" : ""
          )
      );

    dispatch(SetTASK({ form: task?.form, task: newTask }));
    dispatch(SetPARAMS({ key: "tissue", value: padded }));
  };

  const handleKeyDown = (e, rowIdx, colIdx) => {
    if (e.key === "Enter") {
      e.preventDefault();

      // hanapin next input (col muna, tapos row)
      const nextCol = colIdx + 1;
      if (inputRefs.current[rowIdx]?.[nextCol]) {
        inputRefs.current[rowIdx][nextCol].focus();
        inputRefs.current[rowIdx][nextCol].select();
      } else if (inputRefs.current[rowIdx + 1]?.[0]) {
        inputRefs.current[rowIdx + 1][0].focus();
        inputRefs.current[rowIdx + 1][0].select();
      } else {
        setActiveTab("Others"); // move to next tab
      }
    }
  };

  return (
    <MDBTable hover responsive className="mb-0" small>
      <tbody>
        {Echo.TissueDoppler.map((item, index) => (
          <tr key={index}>
            <td>{item}</td>
            {new Array(3).fill("").map((_, i) => {
              const extensions = ["E:", "A:"];

              return (
                <td key={i}>
                  <span style={{ fontWeight: 400 }}> {extensions[i]} </span>
                  <input
                    type="number"
                    className="sectInput  text-center fw-bold mr-1"
                    ref={(el) => {
                      if (!inputRefs.current[index]) {
                        inputRefs.current[index] = [];
                      }
                      inputRefs.current[index][i] = el;
                    }}
                    value={
                      Array.isArray(tissueValues[index])
                        ? tissueValues[index][i] ?? ""
                        : ""
                    }
                    onChange={(e) => handleChange(e.target.value, index, i)}
                    onKeyDown={(e) => handleKeyDown(e, index, i)}
                  />
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </MDBTable>
  );
}
